module.exports = __webpack_public_path__ + "static/media/training.c15ae2f1.jpg";